import { render } from "./model-event.vue?vue&type=template&id=af6ce860"
import script from "./model-event.vue?vue&type=script&lang=js"
export * from "./model-event.vue?vue&type=script&lang=js"

import "./model-event.vue?vue&type=style&index=0&id=af6ce860&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/ALL_REPO/Web-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__